import { useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { useChatContext } from './AIChatProvider';
import Message from './Message';
import AIChatContentFooter from './AIChatContentFooter';
import AIConversationStarter from './AIConversationStarter';


const AIChatContent = () => {
    const {
        currentConversation
    } = useChatContext();

    //const messageEndRef = useRef<null | HTMLSpanElement>(null);

    useEffect(() => {
        //messageEndRef.current?.scrollIntoView();
    }, [currentConversation]);


    if (currentConversation) {

        return (
            <Card className="h-100 w-100">
                {/* <ChatContentHeader /> */}

                <Card.Body className="p-3 p-sm-4 scrollbar d-flex flex-column gap-2 bg-soft-primary">
                    {currentConversation.messages.length === 0 && <AIConversationStarter />}
                    {currentConversation.messages.map((message, index) => (
                        <Message
                            message={message}
                            key={index}
                        />
                    ))}
                    {/*<span ref={messageEndRef} /> */}
                </Card.Body>


                <AIChatContentFooter />

            </Card>
        );
    } else {
        return <></>;
    }
};

export default AIChatContent;
